/**
 * One-line subtitles for the agent's file tools (file-ops contract §2): the `cloud:` path(s) they
 * act on, shown next to the tool's label in the thread.
 */

type ToolArgs = Record<string, unknown>

function pickString(args: ToolArgs, keys: readonly string[]): string {
  for (const key of keys) {
    const v = args[key]
    if (typeof v === 'string' && v.trim()) return v.trim()
  }
  return ''
}

const PATH_KEYS = ['file_path', 'path', 'target_file', 'filepath'] as const

function transferSummary(args: ToolArgs): string | undefined {
  const source = pickString(args, ['source', 'src', 'from'])
  const destination = pickString(args, ['destination', 'dest', 'to'])
  if (source && destination) return `${source} → ${destination}`
  return source || destination || undefined
}

function confirmSummary(args: ToolArgs): string | undefined {
  const paths = args.paths
  if (!Array.isArray(paths)) return undefined
  const n = paths.length
  return `Confirmed changes: ${n} ${n === 1 ? 'file' : 'files'}`
}

/** Subtitle for a file tool call, or `undefined` (other tools, or arguments still streaming). */
export function fileToolSummaryLine(toolName: string, args: ToolArgs): string | undefined {
  switch (toolName) {
    case 'move_file':
    case 'copy_file':
      return transferSummary(args)
    case 'confirm_file_changes':
      return confirmSummary(args)
    case 'write_file':
    case 'edit_file':
    case 'make_folder':
    case 'delete':
      return pickString(args, PATH_KEYS) || undefined
    default:
      return undefined
  }
}
